import { render } from "./SessionOnHoldOverlay.vue?vue&type=template&id=086815e6&scoped=true"
import script from "./SessionOnHoldOverlay.vue?vue&type=script&lang=js"
export * from "./SessionOnHoldOverlay.vue?vue&type=script&lang=js"

import "./SessionOnHoldOverlay.vue?vue&type=style&index=0&id=086815e6&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086815e6"]])

export default __exports__